var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "VIEW",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-626.18 -496.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_431",
    "data-name": "Pfad 431",
    fill: "#f5f5f5",
    d: "M642.18,498.143a14,14,0,1,1-14,14,14.016,14.016,0,0,1,14-14m0-2a16,16,0,1,0,16,16,16,16,0,0,0-16-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_19",
    "data-name": "Vereinigungsmenge 19",
    className: "cls-1",
    fill: "#f5f5f5",
    strokeMiterlimit: 10,
    stroke: "rgba(0,0,0,0)",
    d: "M6132.391-2029.216l-.212-.338.186-.354c.129-.246,3.22-5.95,11.193-5.95h.19a15.283,15.283,0,0,1,12.135,5.877l.3.428-.328.406a17,17,0,0,1-12.1,5.837l-.3,0A13.479,13.479,0,0,1,6132.391-2029.216Zm6.738-.365a4.657,4.657,0,0,0,4.651,4.651,4.658,4.658,0,0,0,4.652-4.651,4.658,4.658,0,0,0-4.652-4.652A4.657,4.657,0,0,0,6139.129-2029.581Zm-5.318-.027a12.324,12.324,0,0,0,6.7,4.54,5.568,5.568,0,0,1-2.312-4.513,5.571,5.571,0,0,1,2.362-4.553A10.939,10.939,0,0,0,6133.811-2029.608Zm15.551.027a5.571,5.571,0,0,1-2.046,4.313,16.621,16.621,0,0,0,7.079-4.343,14.268,14.268,0,0,0-7.244-4.409A5.575,5.575,0,0,1,6149.362-2029.581Zm-8.373,0a2.791,2.791,0,0,1,2.791-2.791,2.791,2.791,0,0,1,2.791,2.791,2.791,2.791,0,0,1-2.791,2.79A2.791,2.791,0,0,1,6140.989-2029.582Z",
    transform: "translate(-5501.999 2542)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.f134c71635de29254c61c8b689641891.svg";
export { ForwardRef as ReactComponent };